/**
 * アカウント設定ページ用のスクリプト
 */
 if (is_route('reserve_transfer_vehicle.index')) {
    // コンテンツ読み込み後
    $(document).on('amc:onload', function() {
        reserve_transfer_vehicle_event_set();
        reserve_transfer_vehicle_setting_event_set();
        reserve_transfer_vehicle_detail_event_set();
    });
}
/**
 * ページ読み込み時のイベント設定
 */
 window.reserve_transfer_vehicle_event_set = function() {

    /*---- 設定表示時 ----*/

    // 設定表示時
    $(document).on('click', '[data-setting-modal]', function () {
        _modal.create(this, 'setting-modal', ['id'], true);
    });
    
    // /*---- 設定の保存時 ----*/

    // // 設定保存時
    // $(document).on('click', '[data-save-modal]', function () {
    //     _modal.submit(this, 'save-modal');
    // });

    /*---- 削除確認時 ----*/

    // 削除確認時
    $(document).on('click', '[data-confirm-modal]', function () {
        _modal.create(this, 'confirm-modal', ['id']);
    });

    /*---- 削除時 ----*/

    // 削除実行時
    $(document).on('click', '[data-delete-modal]', function () {
        _modal.submit(this, 'delete-modal');
    });

    /*---- 詳細表示時 ----*/

    // 詳細表示時
    $(document).on('click', '[data-detail-modal]', function () {
        _modal.create(this, 'detail-modal', ['reserve_id'], true);
    });

    /*---- 実行確認時 ----*/

    // 実行確認時
    $(document).on('click', '[data-execute-confirm-modal]', function () {
        _modal.create(this, 'execute-confirm-modal', ['id']);
    });

    /*---- 予約実行時 ----*/

    // 予約実行時
    $(document).on('click', '[data-execute-modal]', function () {
        _modal.submit(this, 'execute-modal');
    });

    /*---- CSVダウンロード時 ----*/

    // CSVダウンロード時
    $(document).on('click', '#search-form-action_download', function () {
        // アクションの取得
        let action = extend_url_query($(this).data('action'));
        // 検索フォームを配列化
        let datas = $('#search-form').serializeArray();
        // ポスト送信を実行
        post(action, datas);
    });
}
/**
 * 設定モーダル表示時のイベント設定
 */
 window.reserve_transfer_vehicle_setting_event_set = function() {

    /*---- 会社選択時 ----*/

    $(document).on('change', '#reserve_transfer_vehicle-setting-modal-company_id', function() {
        if ($(this).val().length > 0) {
            $('.csv-upload').removeClass('display-none');
        } else {
            $('.csv-upload').addClass('display-none');
        }
        // 会社変更した場合、既にアップロードしたCSVデータをクリアする
        $('#reserve_transfer_vehicle-setting-modal-csv').val('');
        let modalId = '#reserve_transfer_vehicle-setting-modal';
        $(modalId + '-csv-error').addClass('display-none');
        $(modalId + '-csv-error').empty();
        $(modalId + '-csv-submit-message').addClass('display-none');
        $(modalId + '-csv-submit-message').empty();
    });

    /*---- CSVアップロード表示時 ----*/

    // CSVアップロード表示時
    $(document).on('click', '#search-form-action_upload', function () {
        // 初期化処理
        $('#reserve_transfer_vehicle-setting-modal-csv-submit-message').addClass('display-none');
        $('#reserve_transfer_vehicle-setting-modal-csv-submit-message').empty();
        $('#reserve_transfer_vehicle-setting-modal-csv-error').addClass('display-none');
        $('#reserve_transfer_vehicle-setting-modal-csv-error').empty();
        $('#reserve_transfer_vehicle-setting-modal-csv').val('');
    });

    /*---- CSVアップロード確認時 ----*/

    // CSVアップロード確認時
    $(document).on('change', '#reserve_transfer_vehicle-setting-modal-csv', function () {
        let modalId = '#reserve_transfer_vehicle-setting-modal';
        let formId = '#reserve_transfer_vehicle-setting-modal-form';
        let action = $(formId).data('confirm-action');
        let datas = new FormData($(formId).get(0));
        $(modalId + '-csv-error').addClass('display-none');
        $(modalId + '-csv-error').empty();
        $(modalId + '-csv-submit-message').addClass('display-none');
        $(modalId + '-csv-submit-message').empty();
        // $("#reserve_transfer_vehicle-setting-modal-save-button").prop("disabled", true);
        console.log(action);
        console.log(datas);
        // 送信
        _ajax.file(action, datas, function (results) {
            console.log(results);
            $(modalId + '-csv-submit-message').removeClass('display-none');
            $(modalId + '-csv-submit-message').text(results.messages[0]);
            // $("#reserve_transfer_vehicle-setting-modal-save-button").prop("disabled", false);
        }, function(xhr, status, errorThrown){
            $('#reserve_transfer_vehicle-setting-modal-csv').val('');
            $(modalId + '-csv-error').append($('<li></li>').text('CSVファイルを確認してください。CSVの内容は保存されません。'));
            // フォームにエラーメッセージを配置
            $.each(xhr.responseJSON.errors, function(name, message) {
                $(modalId + '-csv-error').removeClass('display-none');
                $(modalId + '-csv-error').append($('<li></li>').text(message));
            });
            _error.omitted(xhr, status, errorThrown, false);
        });
    });

    /*---- 保存＆CSVアップロード時 ----*/

    // 保存ボタンクリック時
    $(document).on('click', '#reserve_transfer_vehicle-setting-modal-save-button', function () {
        let modalId = '#reserve_transfer_vehicle-setting-modal';
        let formId = '#reserve_transfer_vehicle-setting-modal-form';
        let action = $(formId).attr('action');
        let datas = new FormData($(formId).get(0));
        // 送信前にエラーをリセット
        _error.reset()
        // 送信
        _ajax.file(action, datas, function (results) {
            // 完了メッセージをセットする
            _complete.set(results);
            // モーダルを閉じる
            _modal.hide(modalId);
            // コンテンツの読込
            load_contents();
        }, function(xhr, status, errorThrown){
            // エラーをセットする
            _error.set(modalId, xhr, status, errorThrown, false);
        });
    });

    /*---- ヘルプボタン押下時 ----*/

    $(document).on('click', '.modal-reserve_transfer_vehicle-description', function () {
        _modal.show('#reserve_transfer_vehicle-csv-description-modal');
    });
}

/**
 * 詳細モーダル表示時のイベント設定
 */
 window.reserve_transfer_vehicle_detail_event_set = function () {

    /*---- 詳細検索時 ----*/

    // 詳細検索時
    $(document).on('change', '#reserve_transfer_vehicle-detail-modal-vehicle_code, #reserve_transfer_vehicle-detail-modal-vehicle_name', function() {
        let form = $(this).parents('form');
        let datas = $(form).serializeArray();
        let action = $(form).attr('action');
        let modalId = $(form).data('modal_id');
        _modal.update(modalId, action, datas);
    });
}
